import React from 'react';
import Layout from '../components/layout/Layout';
import Hero from '../components/sections/Hero';
import Services from '../components/sections/Services';
import About from '../components/sections/About';
import TrustIndicators from '../components/sections/TrustIndicators';
import Projects from '../components/sections/Projects';
// import Testimonials from '../components/sections/Testimonials';
import FAQ from '../components/sections/FAQ';

const HomePage: React.FC = () => {
  React.useEffect(() => {
    document.title = "OetterliApps | Kosteneffiziente App-Entwicklung mit KI-Integration | Schweiz";
  }, []);

  return (
    <Layout>
      <Hero />
      <TrustIndicators />
      <Services />
      <About />
      <Projects />
      {/* <Testimonials /> */}
      <FAQ />
    </Layout>
  );
};

export default HomePage;
